import MatomoMessage from '@/matomo/message/MatomoMessage';
import { MatomoActions } from '@/matomo/MatomoActions';
import MatomoCookieService from '@/services/matomo/MatomoCookieService';
import MatomoConfigService from '@/services/matomo/MatomoConfigService';

export default class MatomoInitializerService {
  private static instance = new MatomoInitializerService();

  private setUserId = new MatomoMessage([MatomoActions.setUserId]);
  private trackPageView = new MatomoMessage([MatomoActions.trackPageView]);
  private enableLinkTracking = new MatomoMessage([MatomoActions.enableLinkTracking]);
  private trackVisibleContentImpression = new MatomoMessage([MatomoActions.trackVisibleContentImpressions]);
  private setTrackerUrl = new MatomoMessage([MatomoActions.setTrackerUrl]);
  private setSiteId = new MatomoMessage([MatomoActions.setSiteId]);
  private forgetUserOptOutMessage = new MatomoMessage([MatomoActions.forgetOptOut]);

  private matomoCookieService = MatomoCookieService.singleton();
  private matomoConfigService = MatomoConfigService.singleton();

  private constructor() {}

  public static singleton(): MatomoInitializerService {
    return this.instance;
  }

  public initializeMatomo() {
    if (this.matomoConfigService.areRequiredParametersPresent() && this.matomoCookieService.isTrackingAllowed()) {
      this.includeTrackerScript();
    }
  }

  private includeTrackerScript() {
    const params = this.matomoConfigService.getParameters();

    this.createMatomoQueueIfMissing();

    this.setUserId.with(params.userId).publish();
    this.trackPageView.publish();
    this.enableLinkTracking.publish();
    this.trackVisibleContentImpression.publish();
    this.forgetUserOptOutMessage.publish();

    this.setTrackerUrl.with(this.appendToUrl(params.matomoUrl, 'matomo.php')).publish();
    this.setSiteId.with(params.matomoId).publish();

    const matomoScript = document.createElement('script');
    const firstScriptElement = document.getElementsByTagName('script')[0];

    matomoScript.type = 'text/javascript';
    matomoScript.async = true;
    matomoScript.src = this.appendToUrl(params.matomoUrl, 'internjs');

    firstScriptElement.parentNode.insertBefore(matomoScript, firstScriptElement);
  }

  private appendToUrl(matomoUrl: string, postfix: string): string {
    if (matomoUrl.endsWith('/')) {
      return matomoUrl + postfix;
    }

    return matomoUrl + '/' + postfix;
  }

  private createMatomoQueueIfMissing() {
    (window as any)._paq = (window as any)._paq || [];
  }
}
